import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { ProductCategoryClient } from '@frontend/group/api';
import { useAccountRepository } from '@frontend/repository';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { triggerRefetch } from '../../../../redux/detail-modal-slice';
import { useAppDispatch } from '../../../../redux/store';
import { LinkProductsModalProps } from './link-products-modal.component';

interface ViewProps {
    currentAccount: string;
    formValues: { product_ids: string[] };
    selectedProducts: string[];
    setSelectedProducts: (products: string[]) => void;
    onSubmit: () => Promise<{ success: boolean }>;
}

export const useLinkProductsModal = (props: LinkProductsModalProps): ViewProps => {
    const { currentAccount } = useAccountRepository();
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);

    const onSubmit = async () => {
        if (!currentAccount || selectedProducts.length === 0) {
            throw new Error(intl.formatMessage({ id: 'link-products-modal.error-no-products', defaultMessage: 'No products selected' }));
        }

        try {
            await ProductCategoryClient.postProductCategoryMemberList(currentAccount, props.groupId, EntityType.PRODUCT, selectedProducts);
            dispatch(triggerRefetch({ entityType: EntityType.PRODUCT_CATEGORY, entityId: props.groupId }));
            return { success: true };
        } catch (error) {
            ErrorHandler.handleError({ error: error as Error });
            throw error;
        }
    };

    return {
        currentAccount: currentAccount || '',
        formValues: { product_ids: selectedProducts },
        selectedProducts,
        setSelectedProducts,
        onSubmit
    };
};
